import constate from 'constate';
import { useCallback, useState } from 'react';
import { IconType } from '@components/FocusableIconButton';
interface Modal {
  title: string;
  initialFocusKey: string;
  exitFocusKey: string;
  buttons: ModalButton[];
}
export interface ModalButton {
  text: string;
  onClick: () => void;
  iconType: IconType;
  focusKey?: string;
}

const useModal = () => {
  const [visible, setVisible] = useState<boolean>(false);

  const [modalInfo, setModalInfo] = useState<Modal>({
    title: '',
    initialFocusKey: '',
    exitFocusKey: '',
    buttons: []
  });

  const openModal = useCallback((info: Modal) => {
    setModalInfo({
      title: info.title,
      initialFocusKey: info.initialFocusKey,
      exitFocusKey: info.exitFocusKey,
      buttons: info.buttons
    });
    setVisible(true);
  }, []);

  const closeModal = useCallback(() => {
    setVisible(false);
  }, []);
  
  return {
    visible,
    modalInfo,
    openModal,
    closeModal
  };
};

export const [ModalProvider, useModalContext] = constate(useModal);
